// extracted by mini-css-extract-plugin
export default {"container":"LoginPage_container__ZK1ET","loginFormContainer":"LoginPage_loginFormContainer__2qGWh","logo":"LoginPage_logo__KmA0k","rectangles":"LoginPage_rectangles__6p1cM"};